import { Flex, GroupOutlinedIcon, Text } from '@shared/components';

export default function RegistrationExamineesDataGridNoRowsOverlay() {
  return (
    <Flex
      sx={(theme) => ({
        py: theme.spacing(4),
        gap: theme.spacing(4),
        flexDirection: 'column',
        alignItems: 'center',
      })}
    >
      <GroupOutlinedIcon sx={(theme) => ({ fontSize: '48px', color: theme.palette.grey[400] })} />
      <Text variant='h5'>ยังไม่มีรายชื่อผู้เข้าสอบ</Text>
    </Flex>
  );
}
